<script>
import { Line, mixins } from 'vue-chartjs';
import utility from '../Utility/utility';
const { reactiveProp } = mixins;

export default {
    extends: Line,
    mixins: [reactiveProp],
    computed: {
        options() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                fill: false,
                tooltips: {
                    enabled: true,
                    titleFontSize: 14,
                    titleMarginBottom: 8,
                    bodyFontSize: 15,
                    bodySpacing: 10,
                    callbacks: {
                        label: (tooltipItems, data) => {
                            const index = tooltipItems.index;
                            return ` ${utility._getMoneyFormat(
                                this.chartData.datasets[0].data[index]
                            )}`;
                        }
                    }
                },
                // annotation: {
                //   annotations: [
                //     {
                //       type: "line",
                //       mode: "horizontal",
                //       scaleID: "y-axis-0",
                //       borderColor: "green",
                //       value: 20000,
                //       label: {
                //         content: "",
                //         enabled: true,
                //       }
                //     }
                //   ]
                // },
                onClick: this.handle
            };
        }
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        handle(point, event) {
            const item = event[0];
            this.$emit('on-receive', {
                index: item._index,
                value: this.chartData.datasets[0].data[item._index],
                label: this.chartData.labels[item._index]
            });
        }
    }
};
</script>
